var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseAtTask = function SvgPauseAtTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.083 17.328h21.883M11.213 15.212l.99-.024 6.666-.156 1.124-.027c.704-.144 4.176-2.507-3.933-2.5-2.784-1.665-4.174-3.86-6.014-5.882L8.1 7.02l3.07 5.41c-4.827.094-5.262-1.04-6.242-2.77l-1.886.154c1.973 2.026 1.512 4.767 8.172 5.397"
  })));
};
export default SvgPauseAtTask;